<template>
  <div class="py-4 container-fluid">
    <div class="row"></div>
    <div class="row">
      <div class="col-12">
        <!-- <projects-table /> -->
        <div class="row mspacer">
          <div class="card col-sm-9">
            <div class="row mspacer rbcgnd">
              <div class="col-sm-6 spacecols">
                <div class="card cardlink">
                  <a class="my-link" href="item_stock/0"
                    ><span class="fontlinks">Stocks-in-store</span></a
                  >
                  <!-- <span class="righter">tip</span> -->
                </div>
              </div>
              <!-- <div class="col-sm-6 spacecols">
                <div class="card cardlink">
                  <a class="my-link" href="#"
                    ><span class="fontlinks">Stocks-taking</span></a
                  >
                </div>
              </div> -->
              <div class="col-sm-6 spacecols">
                <div class="card cardlink">
                  <a class="my-link" href="purchase_orders"
                    ><span class="fontlinks">Local-Purchase Orders</span></a
                  >
                </div>
              </div>

              <div class="col-sm-6 spacecols">
                <div class="card cardlink">
                  <a href="/finance/inventory_and_sales"
                    ><span>Sales-Analysis</span></a
                  >
                </div>
              </div>
            </div>
            <!--  -->
            <div class="card mborder">
              <div class="card mb-4">
                <div class="card-header pb-0">
                  <h6>Nearly Expiring Drugs / Items</h6>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                  <div class="table-responsive p-0">
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Drug / Item
                          </th>
                          <th
                            class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                          >
                            Time-to-expiry
                          </th>
                          <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Traced-store(s)
                          </th>
                          <th
                            class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                          >
                            Total-available-Quantity
                          </th>
                          <th class="text-secondary opacity-7"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in expiringStocks" :key="item.id">
                          <td>
                            <div class="d-flex px-2 py-1">
                              <!-- <div>
                                <soft-avatar
                                  :img="item.img || 'default-img-url'"
                                  size="sm"
                                  border-radius="lg"
                                  class="me-3"
                                  alt="item-image"
                                />
                              </div> -->
                              <div
                                class="d-flex flex-column justify-content-center"
                              >
                                <h6 class="mb-0 text-sm">
                                  {{ item.item_name }}
                                </h6>
                                <p class="text-xs text-secondary mb-0">
                                  {{ item.brand_name }} |
                                  {{ item.category_name }}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p class="text-xs font-weight-bold mb-0">
                              {{ daysToExpiry(item.expiry_date) }}
                            </p>
                          </td>
                          <td class="align-middle text-center text-sm">
                            <soft-badge
                              color="success"
                              variant="gradient"
                              size="sm"
                            >
                              {{ item.store_name }}
                            </soft-badge>
                          </td>
                          <td class="align-middle text-center">
                            <span
                              class="text-secondary text-xs font-weight-bold"
                            >
                              {{ item.c_quantity }}
                            </span>
                          </td>
                          <td class="align-middle">
                            <a
                              href="javascript:;"
                              class="text-secondary font-weight-bold text-xs"
                              data-toggle="tooltip"
                              data-original-title="Edit"
                            >
                              No-action
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <!--  -->
          </div>

          <div class="card col-sm-3">
            <h4>Resource Links</h4>
            <ul class="link-list">
              <li><a href="#">General Settings</a></li>
              <li><a href="item_register">Items Register</a></li>
              <li><a href="item_categories">Items Categories</a></li>
              <li><a href="item_classes">Item Classes</a></li>
              <li><a href="item_stores">Inventory Stores</a></li>
              <li><a href="item_suppliers">Item Suppliers</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "inventory",
  data() {
    return {
      expiringStocks: [],
    };
  },
  mounted() {
    this.getExpiringStocks();
  },
  methods: {
    async getExpiringStocks() {
      try {
        const res = await generalApiRequest("stocks/expiring", "GET", {}, 1);
        console.log(res);

        this.expiringStocks = res.data.data;
      } catch (error) {
        console.error("Failed to fetch expiring stocks", error);
      }
    },
    daysToExpiry(expiryDate) {
      const expiry = new Date(expiryDate);
      const now = new Date();
      const timeDiff = expiry - now;
      const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
      return days <= 0 ? "Expired" : `${days} days`;
    },
  },
};
</script>

<style scoped>
.cardlink {
  padding: 1em;
  box-shadow: 5px 10px 8px rgba(0, 0, 0, 0.2);
}
.spacecols {
  padding-top: 0.5em;
  padding-bottom: 0.4em;
}
.mspacer {
  padding: 1em;
  border-radius: 1em;
}
.mborder {
  border: "1px solid grey";
}
.rbcgnd {
  background-color: rgb(224, 224, 224);
  /* margin-top:2em !important; */
  margin-right: 1em;
}
.fontlinks {
  font-weight: bold;
  color: black;
}
.righter {
  margin-left: auto !important;
}
a:hover {
  background-color: #98fc03;
}

.card h2 {
  margin-bottom: 10px;
  text-align: center;
}

.link-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.link-list li {
  margin-bottom: 5px;
  /* Add a border-bottom style here */
  border-bottom: 1px solid #ddd;
}

.link-list a {
  color: #333;
  text-decoration: none;
  display: block;
  padding: 10px 15px;
  transition: background-color 0.2s ease-in-out;
}

.link-list a:hover {
  background-color: #f5f5f5;
}
</style>
